/* eslint-disable no-duplicate-imports */
import * as React from 'react';

export interface IBusinessSignUpDropdownProps {
    id?: string;
    value: string;
    className: string;
    isRequired: boolean;
    options: IBusinessSignUpDropdownOption[];
    onChange: (event: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
    fieldReference?: React.RefObject<HTMLSelectElement>;
    selectValue: IBusinessSignUpDropdownOption;
    isSubmittedPressed: boolean;
    resources: any;
}

export interface IBusinessSignUpDropdownOption {
    key: string;
    value: string;
}

export const BusinessSignUpDropdown: React.FC<IBusinessSignUpDropdownProps> = ({
    id,
    value,
    className,
    isRequired,
    options,
    onChange,
    fieldReference,
    selectValue,
    isSubmittedPressed,
    resources
}) => {
    return (
        <select
            id={id}
            value={selectValue?.key}
            className={`msc-address-form__dropdown ms-form__dropdown ${selectValue.value === '' && isSubmittedPressed && 'necessary'}`}
            aria-required={isRequired}
            onChange={(event: any) => onChange(event)}
        >
            <option disabled selected value={''}>
                {resources.select}
            </option>
            {options.map((option: IBusinessSignUpDropdownOption) => {
                return (
                    <option key={option.key} value={option.key}>
                        {option.value}
                    </option>
                );
            })}
        </select>
    );
};

export default BusinessSignUpDropdown;
